import { Heading3 } from '@casavo/base-ui'
import cn from 'classnames'
import { useFormikContext } from 'formik'
import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'
import * as Yup from 'yup'

import { FormikOneOptionSelector } from '@/components/FormFields/FormikOneOptionSelector'
import { paddingBottom, paddingTop } from '@/shared-styles/styles.css'
import { getRoomsMinOptions } from '@/utils/criteria-utils'

import { suggestedPropertyFlowStepPaddingTop, suggestedPropertyFlowStepContent } from './styles.css'

export const HouseTypeIntialValue = () => ({ numberOfRooms: null })

export const HouseTypeValidation = () =>
  Yup.object().shape({
    roomsMin: Yup.string().required().oneOf(['1', '2', '3', '4', '5']),
  })

export const HouseType: React.FC = () => {
  const { t } = useTranslation()
  const { validateForm } = useFormikContext()

  useEffect(() => {
    validateForm()
  }, [])

  return (
    <main className={suggestedPropertyFlowStepPaddingTop}>
      <div className={cn(suggestedPropertyFlowStepContent, paddingTop['3xl'])}>
        <Heading3 className={paddingBottom.m}>{t('suggested:Suggested_Flow_TypeQuestion')}</Heading3>
        <FormikOneOptionSelector
          name="roomsMin"
          options={getRoomsMinOptions(t)}
          style={{ justifyContent: 'flex-start' }}
        />
      </div>
    </main>
  )
}
